export default {
  'Futures': 'Futures',
  'futures_account': 'Futures',
  'future_symbol': 'Symbol',
  'Wallet Balance': 'Wallet Balance',
  'Margin Balance': 'Margin Balance',
  'futures_size': 'Size',
  'Unrealized PNL': 'Unrealized PNL',
  'Entry Price': 'Entry Price',
  'Mark Price': 'Mark Price',
  'ROE%': 'ROE%',
  'From': 'From',
  'To': 'To',
  'futures_positions': 'Positions',
};
